// Display metadata keyed on the raw `health` classification the list endpoint returns.
const HEALTH_CLASSIFICATIONS = {
	at_risk: { label: 'At Risk', color: 'error.main' },
	insufficient: { label: 'Insufficient Data', color: 'text.tertiary' },
	stable: { label: 'Stable', color: 'info.main' },
	strong: { label: 'Strong', color: 'success.main' },
};

/**
 * Returns an MUI theme color path for a given health score classification.
 * Falls back to 'text.primary' for "Insufficient Data" or any unrecognized value.
 * @param {string} classification - e.g. 'At Risk', 'Stable', 'Strong'
 * @returns {string} MUI sx-compatible color string
 */
export const getHealthScoreColor = (classification) => {
	const entry = Object.entries(HEALTH_CLASSIFICATIONS).find(
		([, { label }]) => label === classification
	);
	return entry && entry[0] !== 'insufficient' ? entry[1].color : 'text.primary';
};

/**
 * Display metadata for a raw health classification, or null when the LP has no score.
 * @param {string} classification - 'at_risk' | 'insufficient' | 'stable' | 'strong'
 * @returns {{label: string, color: string}|null}
 */
export const getHealthClassification = (classification) =>
	HEALTH_CLASSIFICATIONS[classification] || null;
